// Adapted from magicui.design/docs/magic-card ("a spotlight effect that
// follows your mouse cursor" — Magic UI's actual component for this is
// called Magic Card; there's no component literally named "Spotlight" or
// "SpotlightCard" in that library). Not a straight port: the upstream
// version draws a colored gradient BORDER around the card and depends on
// `next-themes` for light/dark colors, neither of which fits here — this
// app has no theme switcher, and the ask was "the spotlight follows the
// cursor... revealing the topo texture beneath," which is a mask reveal,
// not a border effect. Kept the real mechanism (cursor-tracked motion
// values via `useMotionTemplate`) and rebuilt the output around it: this
// wrapper exposes `--spot-x`/`--spot-y` CSS custom properties that a child
// layer (the card's TopoTexture) masks itself with, so the texture
// actually brightens under the cursor instead of just growing a border.
import { useRef } from "react";
import { motion, useMotionValue, useMotionTemplate } from "framer-motion";
import { cn } from "@/lib/utils";

export function SpotlightMask({ children, className, size = 220 }) {
  const ref = useRef(null);
  const mouseX = useMotionValue(-size);
  const mouseY = useMotionValue(-size);

  const spotX = useMotionTemplate`${mouseX}px`;
  const spotY = useMotionTemplate`${mouseY}px`;

  const handlePointerMove = (e) => {
    const rect = ref.current?.getBoundingClientRect();
    if (!rect) return;
    mouseX.set(e.clientX - rect.left);
    mouseY.set(e.clientY - rect.top);
  };

  const reset = () => {
    mouseX.set(-size);
    mouseY.set(-size);
  };

  return (
    <motion.div
      ref={ref}
      onPointerMove={handlePointerMove}
      onPointerLeave={reset}
      className={cn("relative", className)}
      style={{ "--spot-x": spotX, "--spot-y": spotY, "--spot-size": `${size}px` }}
    >
      {children}
    </motion.div>
  );
}
